import React, {useState, useEffect, useRef} from 'react'
import {
  //   CardPlanAddToCartStyle,
  CardPlanBodyStyle,
  CardPlanHeaderStyle,
} from '../../kp-11Link-catalog-cards-style'
import {fetchPlanIcon} from '../../../../../../../utils/fetch-plan-icon'
// import {kpSuccessIcon} from '../../../../../../../assets'
import {FloatingInput} from '../../../../kp-11Link-reusable-components/kp-reusable-input'
// import {DELAY_HIDE_IN_SEC} from '../../../../../../../utils/constants'
import {
  buildCartEntity,
  isItemAtMaxQty,
  //   currencySymbolsEnum,
} from '../../../../kp-11Link-utility/kp11-utility'
import {useDispatch, useSelector} from 'react-redux'
import {
  removeItem,
  // selectKP11CartGroups,
  getCatalogCollapseStatus,
  selectKP11SelectCartCentersNApps,
  updateCatalogCollapseStatus,
} from '../../../../../../../app-store/kp11CartSlice'
import {useAuthClient} from '../../../../../../../utils/use-auth-client'
import {useAsync} from '../../../../../../../utils/use-async'
import {kP11LinkService} from '../../../../kp-11Link-utility/kp11-service'
import {Button, Icon} from '@thryvlabs/maverick'
import {ProductNamePriceComponent} from '../../../../../kp-card-type/product-name-price-component'

export const KP11WebsiteDesignCard = ({
  selectedCountry = 'US',
  groupKey,
  item,
  onSelectItem,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
  disabled,
  isChecked,
  addedToCart,
  customFields,
}) => {
  const client = useAuthClient()
  const {run} = useAsync({status: 'pending'})
  const [websiteUrl, setWebsiteUrl] = useState('')
  const [isExistingWebsite, setExistingWebsiteStatus] = useState(null)
  const [validDomainResponse, setValidDomainResponse] = useState({})
  const [isValueEntered, setValueObservabilityStatus] = useState(false)
  const [iconDetail, setIconDetail] = useState(null)
  // const cartGroups = useSelector(selectKP11CartGroups)
  const lastInputTimeRef = useRef(null)
  const debounceTimerRef = useRef(null)
  const cardCollapseStatus = useSelector(getCatalogCollapseStatus)
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const isMaxQtyReached = isItemAtMaxQty({
    cartCentersAndApps,
    item,
  })

  // const selectedItem =
  //   cartGroups.find(g => g.key === groupKey)?.item?.[0] || null

  useEffect(() => {
    const iconDetail = fetchPlanIcon(item?.name || 'Website Design')
    setIconDetail(iconDetail)
  }, [])
  const dispatch = useDispatch()
  useEffect(() => {
    clearTimeout(debounceTimerRef.current)

    const now = Date.now()
    lastInputTimeRef.current = now

    if (websiteUrl.trim().length === 8) {
      // Immediate validation if exactly 8 characters
      validateWebsite()
    } else {
      // Delay-based validation
      debounceTimerRef.current = setTimeout(() => {
        const timeSinceLastInput = Date.now() - lastInputTimeRef.current
        if (timeSinceLastInput >= 1000) {
          validateWebsite()
        }
      }, 1000)
    }

    return () => clearTimeout(debounceTimerRef.current)
  }, [websiteUrl])
  // const updateCartDetails = () => {
  //   const updatedItem = buildCartEntity({
  //     kind: 'item',
  //     source: {
  //       ...item,
  //       groupKey,
  //       section: 'apps',
  //     },
  //     customFields: selectedItem?.customFields ?? {},
  //     keepAddons: false,
  //   })
  //   onSelectItem(updatedItem)
  // }
  const validateWebsite = async () => {
    try {
      const response = await kP11LinkService.validateExistingWebsiteUrl(
        run,
        client,
        websiteUrl,
      )
      setValidDomainResponse(response)
      if (!isValueEntered) {
        setValueObservabilityStatus(true)
      }
      if (!response.status === 'valid') {
        setWebsiteUrl('')
        dispatch(removeItem({groupKey, itemCode: item.code}))
      } else {
        // updateCartDetails()
      }
    } catch (err) {
      //const errorCode = err?.code?.toUpperCase?.() || ''
      console.log(err)
    }
  }

  const handleBlur = () => {
    if (websiteUrl.length > 0) {
      validateWebsite()
    }
    if (!isValueEntered) {
      setValueObservabilityStatus(true)
    }
  }
  const handleCardAction = () => {
    if (isExistingWebsite === 'yes' && validDomainResponse.status !== 'valid') {
      return
    }
    if (!isChecked) {
      const updatedItem = buildCartEntity({
        kind: 'item',
        source: {
          ...item,
          groupKey,
          section: 'apps',
        },
        customFields: {sensisDomain: websiteUrl ? websiteUrl : null},
      })
      onSelectItem(updatedItem)
    }
  }
  const isCardDisabled = () => {
    if (isExistingWebsite === 'no') {
      return false
    } else if (
      isExistingWebsite === 'yes' &&
      validDomainResponse?.status === 'valid'
    ) {
      return false
    } else {
      return true
    }
  }
  return (
    <CardPlanBodyStyle>
      <div
        className={`d-flex flex-column w-100 ${
          disabled ? 'disable-with-opacity' : ''
        }`}
      >
        {/* <div
          className="d-flex justify-content-between w-100"
          onClick={() => {
            // !disabled && onExpand()
            dispatch(
              updateCatalogCollapseStatus('professionally website design'),
            )
          }}
        >
          <div className="item-content-wrap">
            <div
              className="d-flex align-items-center"
              style={{marginTop: iconDetail?.icon ? '-15px' : '0px'}}
            >
              {iconDetail?.icon && (
                <div className="card-icon">
                  <img
                    src={iconDetail?.icon}
                    alt="plan logo"
                    className="options-logo rounded"
                    style={{height: '50px', width: '50px'}}
                  />
                </div>
              )}
              <div className="plan-item-radio-label">
                {'StandAlone Website'}
              </div>
            </div>
          </div>
          <div>
            <Icon
              type={'solid'}
              variant={
                cardCollapseStatus['professionally website design']
                  ? 'caretDown'
                  : `caretRight`
              }
              height={'15'}
              width={'15'}
              color={'#FF6100'}
            />
          </div>
        </div> */}
        <CardPlanHeaderStyle
          onClick={() => {
            // !disabled && onExpand()
            if (disabled) return
            dispatch(
              updateCatalogCollapseStatus('professionally website design'),
            )
          }}
        >
          <div className="card-heading justify-content-between w-100">
            <div className="d-flex flex-row align-items-center gap-4">
              {iconDetail?.icon && (
                <div className="card-icon">
                  <img
                    src={iconDetail.icon}
                    alt="plan logo"
                    className="options-logo rounded"
                  />
                </div>
              )}
              <div className="card-title-text">{`StandAlone Website`}</div>
            </div>
            <div>
              <Icon
                type={'solid'}
                variant={
                  cardCollapseStatus['professionally website design']
                    ? 'caretDown'
                    : `caretRight`
                }
                height={'15'}
                width={'15'}
                color={'#FF6100'}
              />
            </div>
          </div>
        </CardPlanHeaderStyle>
        {cardCollapseStatus['professionally website design'] && (
          <div className="mt-4 px-2">
            <ProductNamePriceComponent
              cardDetail={item}
              isIconRequired={false}
              isNameRequired={false}
              customFields={validDomainResponse}
              country={selectedCountry}
            />
            <div className="d-flex flex-column gap-4">
              <div className="mt-4">
                Do you have an existing published website you wish to transfer?
              </div>

              <div className="d-flex gap-4" style={{marginTop: '-10px'}}>
                {['yes', 'no'].map(value => (
                  <label
                    key={value}
                    className={`d-flex gap-2 align-items-center ${
                      disabled ? 'disabled' : ''
                    }`}
                  >
                    <input
                      className={`ed-radio-input ${disabled ? 'disabled' : ''}`}
                      type="radio"
                      name="isExternalDomain"
                      value={value}
                      checked={value === isExistingWebsite}
                      onChange={() => {
                        setExistingWebsiteStatus(value)
                        if (value === 'no') {
                          // updateCartDetails()
                        }
                      }}
                      disabled={!!item.isExistingWebsite}
                    />
                    <span className="ed-radio-label">
                      {value.charAt(0).toUpperCase() + value.slice(1)}
                    </span>
                  </label>
                ))}
              </div>
              {isExistingWebsite === 'yes' && (
                <div style={{padding: '0px'}}>
                  <FloatingInput
                    label="Enter Website URL"
                    type="url"
                    value={websiteUrl || ''}
                    onChange={e => setWebsiteUrl(e.target.value)}
                    onBlur={handleBlur}
                    required={true}
                    placeholder="https://example.com"
                  />
                  {validDomainResponse.statusMessage && (
                    <p
                      className="mt-2"
                      style={{
                        color:
                          validDomainResponse.status === 'valid'
                            ? '#5cb85c'
                            : '#d9534f',
                      }}
                    >
                      {validDomainResponse.statusMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center w-100 mt-4">
              <Button
                variant="primary"
                disabled={isCardDisabled() || isMaxQtyReached}
                onClick={handleCardAction}
              >
                Add to Cart
              </Button>
            </div>
          </div>
        )}
      </div>
    </CardPlanBodyStyle>
  )
}
